var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.hasGameStateLoaded)?_c('p',[_vm._v("Loading...")]):[(_vm.inLobby)?_c('game-lobby'):_c('game-layout',{staticClass:"game-layout"})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }